export default __webpack_public_path__ + "static/media/SONGS LIST.5e5eb277.png";